import React, { createContext, useContext, useState, useEffect } from "react";

const CheckoutContext = createContext();

const defaultCheckoutState = {
  cartToken: "",
  shopUrl: "someURL",
  currentStep: 0,
  applyPoints: false,
  orderPoints: 0,
  shippingCost: "",
  sameShippingAddress: false,
  shippingAddressSameAsMain: false,
  billingAddressSameAsMain: false,
  promoCode: "",
  // Checkout steps
  account: {
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    password: "",
    passwordConfirmation: "",
    preferredLanguage: "",
    birthDay: "",
    acceptMarketing: false,
    country: "",
    streetAddress: "",
    state: "",
    address2: "",
    city: "",
    zipcode: "",
    sameShippingAddress: false,
  },
  subscription: {
    frequency: "monthly",
    startDate: "",
  },
  shipping: {
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    country: "",
    state: "",
    streetAddress: "",
    city: "",
    zip: "",
    password: "",
    confirmPassword: "",
    loginEmail: "",
  },
  creditcard: {
    name: "",
    cardnumber: "",
    expirationMonth: "",
    expirationYear: "",
    cvv: "",
    saveCard: false,
  },
  billingAddress: {
    acceptedTerms: false,
    sameAsShipping: false,
    country: "",
    state: "",
    streetAddress: "",
    city: "",
    zipcode: "",
  },
  customer: {},
  shopifyCustomer: {},
  cart: {},
  customSettings: {},
  SaveCreditCard: false,
};

export const GetStep = (cart) => {
  return cart.customerId === "" ? 0 : 1;
};

export const CheckoutContextProvider = ({ children }) => {
  const [checkout, setCheckout] = useState(defaultCheckoutState);

  // Initialize with URL parameters if available
  useEffect(() => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const enrollType = urlParams.get("enrollType");

      // Check if this is an ambassador enrollment with birthdate
      if (enrollType === "ambassador") {
        const birthdate = urlParams.get("birthdate");
        if (
          birthdate &&
          birthdate !== "null" &&
          birthdate !== "undefined" &&
          /^\d{4}-\d{2}-\d{2}$/.test(birthdate)
        ) {
          // Initialize checkout state with parameters from URL
          setCheckout((prev) => ({
            ...prev,
            enrollType: "ambassador",
            newAddress: {
              ...prev.newAddress,
              birthDate: birthdate,
            },
          }));

          // Store in localStorage for internal component communication
          localStorage.setItem("ambassador_birthdate", birthdate);
        }
      }
    } catch (error) {
      console.error("Error initializing from URL parameters:", error);
    }
  }, []);

  return (
    <CheckoutContext.Provider value={{ checkout, setCheckout }}>
      {children}
    </CheckoutContext.Provider>
  );
};

export const useCheckoutContext = () => {
  return useContext(CheckoutContext);
};
